<template>
    <div>
        <div class="container">
            <h2 class="subtitle">Uploading a new image</h2>
        </div>
        <image-form :create="true" @saved="gotoImage"></image-form>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {}
        },
        computed: mapGetters(['images']),
        methods: {
            gotoImage(image) {
                this.$router.push({name: 'image', params: {id: image.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// ImageCreate.vue?1d30a711